/**
 * AlmadarPostWelcomeToAlmadarARAlmadarPostWelcomeToAlmadarARPage
 *
 * Page component for AlmadarPostWelcomeToAlmadarARAlmadarPostWelcomeToAlmadarARPage
 * Path: /ar/blog/welcome-to-almadar
 *
 * @generated from schema
 */

import React from 'react';
import { useLocation } from 'react-router-dom';
import type { EventPayload } from '@almadar/core';
import { AlmadarPostWelcomeToAlmadarARPostPageView as __AlmadarPostWelcomeToAlmadarARPostPageView } from '@/components/traits/AlmadarPostWelcomeToAlmadarARPostPageView';
import { AlmadarPostWelcomeToAlmadarARPostAnalyticsView as __AlmadarPostWelcomeToAlmadarARPostAnalyticsView } from '@/components/traits/AlmadarPostWelcomeToAlmadarARPostAnalyticsView';
import { VStack, UISlotComponent } from '@almadar/ui/components';

interface AlmadarPostWelcomeToAlmadarARAlmadarPostWelcomeToAlmadarARPageProps {
  // Add any page-level props here
}

export function AlmadarPostWelcomeToAlmadarARAlmadarPostWelcomeToAlmadarARPage(_props: AlmadarPostWelcomeToAlmadarARAlmadarPostWelcomeToAlmadarARPageProps) {
  const __navState = (useLocation().state ?? {}) as EventPayload;

  return (
    <>
      <UISlotComponent slot="main">
        <VStack gap="lg" className="w-full">
          <__AlmadarPostWelcomeToAlmadarARPostPageView config={{ initPayload: __navState }} />
          <__AlmadarPostWelcomeToAlmadarARPostAnalyticsView config={{ initPayload: __navState }} />
        </VStack>
      </UISlotComponent>
    </>
  );
}

export default AlmadarPostWelcomeToAlmadarARAlmadarPostWelcomeToAlmadarARPage;
